import { defineStore } from 'pinia';
import { useIntervalFn } from '@vueuse/core';
import * as api from '@src/api/auth';

// 验证码过期时间（秒）
const CAPTCHA_EXPIRE_SECONDS = 120;

export const useStoreCaptcha = defineStore('captcha', () => {
    const captchaInfo = ref<{
        uuid: string;
        img: string;
    }>({
        uuid: '',
        img: '',
    });

    // 倒计时剩余秒数
    const countdown = ref(CAPTCHA_EXPIRE_SECONDS);
    // 是否已过期
    const isExpired = computed(() => countdown.value <= 0);

    // 使用 useIntervalFn 实现倒计时
    const { pause, resume } = useIntervalFn(
        () => {
            if (countdown.value > 0) {
                countdown.value -= 1;
            } else {
                pause();
            }
        },
        1000,
        { immediate: false }
    );

    const getCaptchaInfo = async () => {
        const res = await api.captchaImage();
        const { uuid, img } = res as any;
        Object.assign(captchaInfo.value, {
            uuid,
            img: 'data:image/jpeg;base64,' + img,
        });
        // 获取验证码后重置并启动倒计时
        countdown.value = CAPTCHA_EXPIRE_SECONDS;
        resume();
    };

    // getCaptchaInfo();

    return {
        captchaInfo,
        getCaptchaInfo,
        // 倒计时相关状态
        countdown, // 剩余秒数
        isExpired, // 是否已过期
        expireSeconds: CAPTCHA_EXPIRE_SECONDS, // 过期时间常量
    };
});
